// extracted by mini-css-extract-plugin
export var clickThrough = "_ym-2";
export var fallback = "_ym-5";
export var frame = "_ym-3";
export var frameCell = "_ym-1";
export var overlay = "_ym-4";
export var wrapper = "_ym-0";